import {
  DEFAULT_SEO_DESCRIPTION,
  DEFAULT_SEO_KEYWORDS,
  DEFAULT_SEO_TITLE,
  DEFAULT_ROBOTS,
} from "./seo";

export type StaticSeoEntry = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  ogType?: string;
  robots?: string;
  // Optional relative/absolute image URL for OG/Twitter
  image?: string;
  ogImageType?: string;
  ogImageWidth?: number;
  ogImageHeight?: number;
  siteName?: string;
  locale?: string;
  localeAlternate?: string;
  articlePublisher?: string;
  author?: string;
  publisher?: string;
  themeColor?: string;
  htmlLang?: string;
  twitterSite?: string;
  twitterCreator?: string;
  alternates?: Array<{ hrefLang: string; href: string }>;
  iconHref?: string;
  appleTouchIconHref?: string;
  jsonLd?: any;
};

export const staticSeoByPath: Record<string, StaticSeoEntry> = {
  "/": {
    title: `Page Title | ${DEFAULT_SEO_TITLE}`,
    description:
      "Read Bhagavad Gita, Ramayan, Mahabharat, Puran, Upanishad and Hindu spiritual books online free.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    // Stable public URL (works for crawlers + prerendered HTML)
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/" },
      { hrefLang: "en", href: "https://gitaseva.org/" },
      { hrefLang: "x-default", href: "https://gitaseva.org/" },
    ],
    // Favicons (CRA assets)
    // Note: repo does not currently include `public/favicon.ico`
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Gita Seva",
      url: "https://gitaseva.org",
      logo: "https://gitaseva.org/logo512.png",
      image: "https://gitaseva.org/logo512.png",
      description:
        "Read Bhagavad Gita, Ramayan, Mahabharat, Puran, Upanishad, Bhajans, Aarti and Hindu spiritual books online free.",
      sameAs: [
        "https://www.facebook.com/gitaseva",
        "https://www.instagram.com/gitaseva",
        "https://www.youtube.com/@gitaseva",
      ],
      foundingDate: "2017",
      publisher: {
        "@type": "Organization",
        name: "Gita Seva",
      },
    },
  },
  "/home": {
    title: `Page Title | ${DEFAULT_SEO_TITLE}`,
    description:
      "Read Bhagavad Gita, Ramayan, Mahabharat, Puran, Upanishad and Hindu spiritual books online free.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/home",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/" },
      { hrefLang: "en", href: "https://gitaseva.org/" },
      { hrefLang: "x-default", href: "https://gitaseva.org/" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Gita Seva",
      url: "https://gitaseva.org",
      logo: "https://gitaseva.org/logo512.png",
      image: "https://gitaseva.org/logo512.png",
      description:
        "Read Bhagavad Gita, Ramayan, Mahabharat, Puran, Upanishad, Bhajans, Aarti and Hindu spiritual books online free.",
      sameAs: [
        "https://www.facebook.com/gitaseva",
        "https://www.instagram.com/gitaseva",
        "https://www.youtube.com/@gitaseva",
      ],
      foundingDate: "2017",
      publisher: {
        "@type": "Organization",
        name: "Gita Seva",
      },
    },
  },
  "/books": {
    title: `Books | ${DEFAULT_SEO_TITLE}`,
    description:
      "Browse Bhagavad Gita, Ramayan, Mahabharat, Puran, Upanishad and other Hindu spiritual books online free.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/books",
    ogType: "website",
    robots:
      "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    author: DEFAULT_SEO_TITLE,
    publisher: DEFAULT_SEO_TITLE,
    themeColor: "#FF9933",
    htmlLang: "hi",
    image: "/logo512.png",
    ogImageType: "image/png",
    ogImageWidth: 1200,
    ogImageHeight: 630,
    siteName: DEFAULT_SEO_TITLE,
    locale: "hi_IN",
    localeAlternate: "en_US",
    articlePublisher: "https://facebook.com/gitaseva",
    twitterSite: "@gitaseva",
    twitterCreator: "@gitaseva",
    alternates: [
      { hrefLang: "hi", href: "https://gitaseva.org/books" },
      { hrefLang: "en", href: "https://gitaseva.org/books" },
      { hrefLang: "x-default", href: "https://gitaseva.org/books" },
    ],
    iconHref: "/logo192.png",
    appleTouchIconHref: "/logo192.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "Books",
      url: "https://gitaseva.org/books",
      isPartOf: {
        "@type": "WebSite",
        name: "Gita Seva",
        url: "https://gitaseva.org",
      },
      description:
        "Browse Bhagavad Gita, Ramayan, Mahabharat, Puran, Upanishad and other Hindu spiritual books online free.",
    },
  },
  "/404.html": {
    title: `404 - Page Not Found | ${DEFAULT_SEO_TITLE}`,
    description: "The page you are looking for could not be found on Gita Seva.",
    keywords: DEFAULT_SEO_KEYWORDS,
    path: "/404.html",
    ogType: "website",
    robots: "noindex, follow",
  },
};

